import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, Stack } from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import * as Services from '../../../../../Services/Services';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';

import { IAgeGoup } from '../../../../../Models/AgeGroups/IAgeGroup';
import { IAgeGroupApi } from '../../../../../Services/API/AgeGroup/IAgeGroupApi';
import { IEventType } from '../../../../../Models/EventTypes/IEventType';
import { IEventTypeApi } from '../../../../../Services/API/EventType/IEventTypeApi';
import { EventTypeListView } from './EventTypeListView';
import { EventTypeProperties } from '../EventTypeProperties/EventTypeProperties';
import { EventTypeEnum } from '../../../../../Models/Event/EventTypeEnum';


interface IEventTypeListProps {

}

const dialogStyles = { main: { maxWidth: 450 } };

export const EventTypeList: React.FunctionComponent<IEventTypeListProps> = (props) => {

    const [eventTypeList, setEventTypeList] = React.useState<IEventType[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isPropertiesOpened, setIsPropertiesOpened] = useBoolean(false);
    const [selectedGroup, setSelectedGroup] = React.useState<IEventType>()

    const [isDeleteDialogOpened, setIsDeleteDialogOpened] = useBoolean(false);
    const [eventTypeToDelete, setEventTypeToDelete] = React.useState({ id: 0, desc: "" });

    const labelId: string = useId('dialogLabel');
    const subTextId: string = useId('subTextLabel');

    const modalProps = React.useMemo(
        () => ({
            titleAriaId: labelId,
            subtitleAriaId: subTextId,
            isBlocking: false,
            styles: dialogStyles,
            dragOptions: undefined,
        }),
        [labelId, subTextId],
    );



    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventTypeApi>(Services.EventTypeApi);
        const eventType = await eventTypeApi.getEventTypes(false);

        if (eventType.isSuccess && eventType.data) {
            setStatusMessage({ message: eventType.message, type: MessageBarType.success });
            setEventTypeList(eventType.data);
        }
        else {
            setStatusMessage({ message: eventType.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();

    }

    React.useEffect(() => {
        loadData();
    }, [])

    const deleteEventType = async (eventTypeId: number) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventTypeApi>(Services.EventTypeApi);
        const result = await eventTypeApi.deleteEventType(eventTypeId);

        if (result.isSuccess) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            await loadData();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
        setIsDeleteDialogOpened.setFalse();
    }

    const addNewGroup = () => {
        setSelectedGroup({ description: "", name: "", type: EventTypeEnum.Lessons, longDescription: "", order: 0, id: 0, showOnWeb: true });
        setIsPropertiesOpened.setTrue();
    }

    const refresh = async (id: number) => {
        await loadData();
    }

    const selectGroup = (item: IEventType) => {
        setSelectedGroup(item);
        setIsPropertiesOpened.setTrue();
    }

    const deleteItemDialog = (id: number, desc: string) => {
        setEventTypeToDelete({ id: id, desc: desc });
        setIsDeleteDialogOpened.setTrue();
    }

    const deleteClick = async () => {
        await deleteEventType(eventTypeToDelete.id);
    }

    return (<>
        <EventTypeListView deleteItem={deleteItemDialog} selectItem={selectGroup} isLoading={isLoading} items={eventTypeList} statusMessage={statusMessage} addGroup={addNewGroup} />
        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
        {selectedGroup ?
            <EventTypeProperties item={selectedGroup}
                isOpen={isPropertiesOpened}
                close={setIsPropertiesOpened.setFalse}
                refresh={refresh}
            /> : null}
        {isDeleteDialogOpened ?
            <Dialog
                hidden={!isDeleteDialogOpened}
                onDismiss={setIsDeleteDialogOpened.setFalse}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Odstranit objekt',
                    closeButtonAriaLabel: 'Zavřít',
                    subText: `Opravdu chcete odstranit typ události ${eventTypeToDelete.desc} ?`,
                }}
                modalProps={modalProps}
            >
                <DialogFooter>
                    <PrimaryButton onClick={deleteClick} text="Odstranit" />
                    <DefaultButton onClick={setIsDeleteDialogOpened.setFalse} text="Zrušit" />
                </DialogFooter>
            </Dialog> : null}
    </>
    )
}